<template>
  <!-- <div v-if="!paywallCheck" class=" -->
  <div
    class="flex w-full flex-col justify-between gap-6 rounded-md border border-yellow-500 bg-yellow-10 p-5"
  >
    <div class="flex w-full items-center gap-4">
      <div class="flex flex-1 items-center">
        <div class="mr-4 flex items-center justify-start gap-1">
          <svg
            class="h-5 w-5 text-yellow-500"
            viewBox="0 0 14 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 5.39062C5.80277 7.74145 7.64918 9.58785 10 10.3906C7.64918 11.1934 5.80277 13.0398 5 15.3906C4.19722 13.0398 2.35082 11.1934 0 10.3906C2.35082 9.58785 4.19723 7.74145 5 5.39062Z"
              fill="currentColor"
            />
            <path
              d="M11 0.390625C11.4817 1.80112 12.5895 2.90896 14 3.39062C12.5895 3.87229 11.4817 4.98013 11 6.39062C10.5183 4.98013 9.41049 3.87229 8 3.39062C9.41049 2.90896 10.5183 1.80112 11 0.390625Z"
              fill="currentColor"
            />
          </svg>
          <h3 class="text-base text-dark-gray lg:text-xl">Insight Details</h3>
        </div>
        <div class="flex items-center">
          <custom-badge
            bg-color-class="bg-yellow-500"
            color-class="text-white"
            :size="totalInsightSize"
            :text="`${insights.length} ${totalInsightText}`"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col lg:flex-row lg:items-stretch">
      <div class="flex-1">
        <div class="mb-4 flex items-center gap-4">
          <h3
            v-if="hasInsights(Tabs.Location)"
            class="cursor-pointer"
            :class="
              currentTab === Tabs.Location
                ? 'border-b-2 border-yellow-500 font-semibold text-yellow-500'
                : 'text-gray-500'
            "
            @click="setTab(Tabs.Location)"
          >
            Location
            <span class="ml-0.5">({{ tabCount.Location }})</span>
          </h3>
          <h3
            v-if="hasInsights(Tabs.Operation)"
            class="cursor-pointer"
            :class="
              currentTab === Tabs.Operation
                ? 'border-b-2 border-yellow-500 font-semibold text-yellow-500'
                : 'text-gray-500'
            "
            @click="setTab(Tabs.Operation)"
          >
            Operation
            <span class="ml-0.5">({{ tabCount.Operation }})</span>
          </h3>
          <h3
            v-if="hasInsights(Tabs.Association)"
            class="cursor-pointer"
            :class="
              currentTab === Tabs.Association
                ? 'border-b-2 border-yellow-500 font-semibold text-yellow-500'
                : 'text-gray-500'
            "
            @click="setTab(Tabs.Association)"
          >
            Association
            <span class="ml-0.5">({{ tabCount.Association }})</span>
          </h3>
        </div>
        <div v-if="selectedInsights.length > 0">
          <div class="block lg:hidden">
            <carousel
              ref="carousel"
              :items-to-show="1"
              @update:model-value="onSlideChange"
            >
              <slide
                v-for="insight in selectedInsights"
                :key="`slide-${insight.id}`"
                class="pr-1"
              >
                <div
                  class="h-36 w-full cursor-pointer rounded-md border-2 border-yellow-500 bg-yellow-200 p-2 text-left"
                >
                  <div class="flex flex-col items-start gap-2 rounded-full">
                    <div
                      class="flex gap-1 rounded-full border border-light-gray bg-white px-2 py-1 text-left text-xs text-dark-gray"
                    >
                      <span>{{ insight.title }}</span>
                      <img src="@/assets/exclamation.svg" />
                    </div>
                    <div class="flex flex-wrap">
                      <p class="ml-2 text-left text-xs text-body-color">
                        {{ insight.message_for_brokers }}
                      </p>
                    </div>
                  </div>
                </div>
              </slide>
              <template #addons>
                <div class="pt-4">
                  <pagination />
                </div>
              </template>
            </carousel>
          </div>
          <section class="hidden lg:block">
            <div
              v-for="(insight, index) in selectedInsights"
              :key="insight.id"
              class="mb-4 flex cursor-pointer items-center rounded-md px-2 py-4 hover:bg-yellow-20"
              :class="{
                'rounded border-2 border-yellow-500 bg-yellow-200':
                  selectedId === insight.id,
                'border-2 border-transparent hover:border-yellow-20':
                  selectedId !== insight.id,
              }"
              @click="selectInsight(insight.id)"
            >
              <div class="insight-item relative flex-1 rounded text-left">
                <div class="mb-2">
                  <custom-badge
                    :key="`insight-badge-${index}`"
                    bg-color-class="bg-white"
                    color-class="text-dark-gray"
                    size="md"
                    icon-size="lg"
                    :text="
                      insight.title
                        ?.replace(' Sms ', ' SMS ')
                        ?.replace('Acute Or Critical', 'Acute or Critical')
                        .replace('Vs', 'vs')
                    "
                    :icon="iconName(insight.is_type)"
                    :icon-color-class="iconColorClass(insight.is_type)"
                    class="mr-3 inline-flex self-start border border-light-gray"
                  />
                </div>
                <div
                  v-if="insight.message_for_brokers"
                  class="pl-1 pr-6 text-xs"
                >
                  <ul class="list-outside list-disc pl-4">
                    <li class="list-outside list-disc text-body-color">
                      {{ insight.message_for_brokers }}
                    </li>
                  </ul>
                </div>
                <div class="absolute right-2 top-1/2 h-4 w-4">
                  <svg
                    class="relative -top-1 left-2"
                    width="9"
                    height="14"
                    viewBox="0 0 9 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L0.999999 13"
                      stroke="#6D7181"
                      stroke-width="2"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div
        v-if="selectedInsight"
        class="rounded lg:ml-6 lg:w-2/3"
      >
        <div
          class="relative h-full w-full"
          style="height: 600px"
        >
          <div
            v-show="
              selectedInsight?.is_type === 'broker_authority_same_address'
            "
            class="-top-2px relative flex h-full w-full cursor-pointer flex-col rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <re-used :insight="selectedInsight" />
          </div>
          <div
            v-show="
              selectedInsight?.is_type ===
              'only_accessed_from_outside_north_america'
            "
            class="-top-2px loading-gradient relative h-full w-full cursor-pointer rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <re-used :insight="selectedInsight" />
          </div>
          <div
            v-show="selectedInsight?.is_type === 'broker_authority_nearby'"
            class="-top-2px relative flex h-full w-full cursor-pointer flex-col rounded-md border-2 border-yellow-500"
          >
            <div
              id="broker_authority_nearby_map"
              class="loading-gradient flex h-full w-full flex-1 overflow-hidden rounded-md"
            ></div>
            <google-map-insights
              v-show="
                brokerAuthorityNearbyInsight?.associated_addresses?.length > 0
              "
              :insight="brokerAuthorityNearbyInsight"
              :hq-address="
                brokerAuthorityNearbyInsight?.this_carriers_addresses || {}
              "
              map-id="broker_authority_nearby_map"
            ></google-map-insights>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'undeliverable_address'"
            class="-top-2px relative h-full w-full cursor-pointer overflow-x-hidden overflow-y-scroll rounded-md border-2 border-yellow-500 bg-white p-6"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <undeliverable-address
              :insight="selectedInsight"
            ></undeliverable-address>
          </div>
          <div
            v-show="selectedInsight?.is_type == 'residential_address'"
            class="-top-2px loading-gradient relative h-full w-full cursor-pointer rounded-md border-2 border-yellow-500"
          >
            <google-map-street-view-insights
              v-show="hqAddress"
              :insight="selectedInsight"
              :hq-address="hqAddress"
              map-id="residential_address_map"
              address-type="residential"
            ></google-map-street-view-insights>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'carrier_identifier_changed'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'flagged_factor'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-show="selectedInsight?.is_type == 'virtual_office_address'"
            class="-top-2px loading-gradient relative h-full w-full cursor-pointer rounded-md border-2 border-yellow-500"
          >
            <google-map-street-view-insights
              :insight="selectedInsight"
              :hq-address="selectedInsight?.associated_addresses?.[0]"
              map-id="virtual_office_address_map"
              address-type="virtual"
            />
          </div>
          <div
            v-if="selectedInsight?.is_type == 'no_inspection_history'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500 bg-white p-6"
          >
            <inspection-history-insight
              :insight="selectedInsight"
            ></inspection-history-insight>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'low_inspection_to_truck_count'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500 bg-white p-6"
          >
            <inspection-to-truck-count-insight
              :insight="selectedInsight"
            ></inspection-to-truck-count-insight>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'authority_history_gap'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500 bg-white p-6"
          >
            <authority-history-gap-insight
              :insight="selectedInsight"
            ></authority-history-gap-insight>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'no_class_eight_trucks'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500 bg-white p-6"
          >
            <no-class-eight-trucks-insight
              :insight="selectedInsight"
            ></no-class-eight-trucks-insight>
          </div>
          <div
            v-if="
              selectedInsight?.is_type == 'reused_equipment_same_license_plate'
            "
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-if="
              selectedInsight?.is_type ==
              'equipment_not_listed_on_scheduled_auto'
            "
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <equipment-not-on-scheduled-auto
              :insight="selectedInsight"
            ></equipment-not-on-scheduled-auto>
          </div>
          <div
            v-if="
              selectedInsight?.is_type ==
              'material_reported_vs_scheduled_equipment_contradiction'
            "
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>

            <div
              class="flex h-full w-full flex-col gap-2 rounded-md bg-white p-6 px-3 pt-10"
            >
              <p class="text-2xs font-bold uppercase text-body-color">
                Material Reported Vs Scheduled Equipment Contradiction
              </p>
              <a
                :href="`/broker/carriers/${carrier_id}`"
                target="_blank"
                class="mb-2 text-xl text-yellow-600 underline"
              >
                {{
                  capitalizeWords(
                    $store.state.show.showBroker?.legal_name?.toLowerCase()
                  )
                }}
              </a>
              <div class="flex flex-row">
                <div
                  class="mr-5 flex h-32 w-full flex-col items-center gap-4 rounded-md border border-yellow-500 p-4 pt-6 pt-8 text-center"
                >
                  <div class="text-4xl text-red-500">
                    {{
                      $store.state.carriers.showCarrierInspections
                        ?.reported_power_units || '-'
                    }}
                  </div>
                  <h4 class="text-2xs font-bold uppercase text-body-color">
                    Reported Power Units
                  </h4>
                </div>
                <div
                  class="flex h-32 w-full flex-col items-center gap-4 rounded-md border border-yellow-500 p-4 pt-6 pt-8 text-center"
                >
                  <div class="text-4xl text-red-500">
                    {{ selectedInsight?.scheduled_vehicle_count }}
                  </div>
                  <h4 class="text-2xs font-bold uppercase text-body-color">
                    Observed Power Units
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'fmcsa_email_changed_recently'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'flagged_insurance_agent'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>

          <div
            v-if="selectedInsight?.is_type == 'reused_email_address'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <re-used :insight="selectedInsight" />
          </div>
          <div
            v-if="selectedInsight?.is_type == 'reused_phone'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <re-used :insight="selectedInsight" />
          </div>
          <div
            v-if="selectedInsight?.is_type == 'reused_contact'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <re-used :insight="selectedInsight" />
          </div>
          <div
            v-if="selectedInsight?.is_type == 'associated_digital_activity'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <re-used :insight="selectedInsight" />
          </div>
          <div
            v-if="selectedInsight?.is_type == 'reused_address'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <re-used :insight="selectedInsight" />
          </div>
          <div
            v-if="selectedInsight?.is_type == 'fatal_crash_with_citation'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover />
            <fatal-crash-with-citation :insight="selectedInsight" />
          </div>
          <div
            v-if="
              selectedInsight?.is_type == 'acute_or_critical_sms_violations'
            "
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <acute-or-critical-sms
              :insight="selectedInsight"
            ></acute-or-critical-sms>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'reused_equipment_scheduled_auto'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-if="
              selectedInsight?.is_type == 'fmcsa_phone_number_changed_recently'
            "
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-if="selectedInsight?.is_type == 'highly_used_address_area'"
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-if="
              selectedInsight?.is_type ==
              'user_attempting_to_login_as_wrong_carrier'
            "
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500"
          >
            <insights-box-scroll-cover></insights-box-scroll-cover>
            <re-used :insight="selectedInsight"></re-used>
          </div>
          <div
            v-if="
              selectedInsight?.is_type ==
              'census_contact_has_suspicious_voip_phone_number'
            "
            class="-top-2px relative h-full w-full rounded-md border-2 border-yellow-500 bg-white"
          >
            <template
              v-for="(carrier, index) in selectedInsight.associated_carriers"
              :key="index"
            >
              <div
                class="m-4 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
              >
                <router-link
                  :to="{
                    name: 'Carrier Brokers Show Page',
                    params: { id: carrier.id },
                  }"
                  target="_blank"
                  class="text-xl text-yellow-600 underline"
                >
                  {{ carrier.legal_name }}
                </router-link>
                <div
                  class="flex flex-col gap-4 text-left lg:flex-row lg:gap-10"
                >
                  <div class="flex flex-col">
                    <label
                      class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                    >
                      phone #
                    </label>
                    <label class="text-2xs text-body-color">
                      {{ getVoipPhone(carrier.phones)?.phone_e164 }}
                    </label>
                  </div>
                  <div class="flex flex-col">
                    <label
                      class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                    >
                      phone type
                    </label>
                    <label class="text-2xs text-body-color">
                      {{
                        getVoipPhone(carrier.phones)?.phone_type === 'voip'
                          ? 'VoIP'
                          : '-'
                      }}
                    </label>
                  </div>
                  <div class="flex flex-col">
                    <label
                      class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                    >
                      phone carrier
                    </label>
                    <label class="text-2xs text-body-color">
                      {{ getVoipPhone(carrier.phones)?.carrier_name }}
                    </label>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import GoogleMapStreetViewInsights from '@/components/GoogleMaps/GoogleMapStreetViewInsights.vue';
import GoogleMapInsights from '../GoogleMaps/GoogleMapInsights.vue';
import ReUsed from '@/components/Insights/ReUsed.vue';
import FatalCrashWithCitation from '@/components/Insights/FatalCrashWithCitation.vue';
import InsightsBoxScrollCover from '@/components/Insights/InsightsBoxScrollCover.vue';
import { ref, computed } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import UndeliverableAddress from './UndeliverableAddress.vue';
import EquipmentNotOnScheduledAuto from './EquipmentNotOnScheduledAuto.vue';
import NoClassEightTrucksInsight from './NoClassEightTrucksInsight.vue';
import InspectionHistoryInsight from './InspectionHistoryInsight.vue';
import AuthorityHistoryGapInsight from './AuthorityHistoryGapInsight.vue';
import InspectionToTruckCountInsight from './InspectionToTruckCountInsight.vue';
import AcuteOrCriticalSms from './AcuteOrCriticalSms.vue';

const Tabs = {
  Location: 0,
  Operation: 1,
  Association: 2,
};
const ViewMode = {
  Map: 0,
  List: 1,
};
const categories = {
  Location: [
    'broker_authority_nearby',
    'undeliverable_address',
    'residential_address',
    'virtual_office_address',
    'broker_authority_same_address',
    'only_accessed_from_outside_north_america',
  ],
  Operation: [
    'no_inspection_history',
    'low_inspection_to_truck_count',
    'authority_history_gap',
    'no_class_eight_trucks',
    'reused_equipment_same_license_plate',
    'equipment_not_listed_on_scheduled_auto',
    'fatal_crash_with_citation',
    'acute_or_critical_sms_violations',
    'material_reported_vs_scheduled_equipment_contradiction',
    'fmcsa_phone_number_changed_recently',
    'fmcsa_email_changed_recently',
  ],
  Association: [
    'reused_email_address',
    'reused_phone',
    'reused_contact',
    'reused_address',
    'carrier_identifier_changed',
    'associated_digital_activity',
    'flagged_factor',
    'flagged_insurance_agent',
    'reused_equipment_scheduled_auto',
    'census_contact_has_suspicious_voip_phone_number',
    'highly_used_address_area',
    'user_attempting_to_login_as_wrong_carrier',
  ],
};
export default {
  name: 'InsightsDetail',
  components: {
    CustomBadge,
    GoogleMapStreetViewInsights,
    ReUsed,
    InsightsBoxScrollCover,
    Carousel,
    Slide,
    Pagination,
    FatalCrashWithCitation,
    UndeliverableAddress,
    EquipmentNotOnScheduledAuto,
    GoogleMapInsights,
    NoClassEightTrucksInsight,
    InspectionHistoryInsight,
    AuthorityHistoryGapInsight,
    InspectionToTruckCountInsight,
    AcuteOrCriticalSms,
  },
  props: {
    insights: {
      type: Array,
      required: true,
    },
    screenWidth: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const viewMode = ref(ViewMode.Map);
    const toogleViewMode = () => {
      if (viewMode.value === ViewMode.Map) {
        viewMode.value = ViewMode.List;
        return;
      }
      viewMode.value = ViewMode.Map;
    };
    const carousel = ref(null);
    const getTabKey = (tab) => {
      switch (tab) {
        case Tabs.Operation:
          return 'Operation';
        case Tabs.Association:
          return 'Association';
        default:
        case Tabs.Location:
          return 'Location';
      }
    };

    const onSlideChange = (newValue) => {
      const currentInsight = selectedInsights.value[newValue];
      selectInsight(currentInsight.id);
    };

    const hasInsights = (tab) => {
      const key = getTabKey(tab);
      const is_types = categories[key];

      if (
        props.insights.find((insight) => is_types.includes(insight.is_type))
      ) {
        return true;
      }
      return false;
    };

    const getInitialTab = () => {
      const tabPriority = [Tabs.Location, Tabs.Operation, Tabs.Association];

      for (const tab of tabPriority) {
        if (hasInsights(tab)) {
          return tab;
        }
      }
    };

    const currentTab = ref(getInitialTab());

    const selectedInsights = computed(function () {
      const key = getTabKey(currentTab.value);
      const is_types = categories[key];

      return props.insights.filter((insight) => {
        return is_types.includes(insight.is_type) ? insight : null;
      });
    });

    const tabCount = computed(function () {
      var keys = ['Location', 'Operation', 'Association'];
      var counts = {};
      keys.forEach(function (key) {
        const is_types = categories[key];
        counts[key] = props.insights.filter((insight) => {
          return is_types.includes(insight.is_type) ? insight : null;
        }).length;
      });
      return counts;
    });

    const selectedId = ref(selectedInsights.value[0]?.id);
    const setTab = (tab) => {
      carousel?.value?.slideTo(0);
      currentTab.value = tab;
      selectedId.value = selectedInsights.value[0]?.id;
    };
    const iconColorClass = function (is_type) {
      switch (is_type) {
        case 'undeliverable_address':
          return 'text-dark-gray';
        case 'residential_address':
          return 'text-dark-gray';
        case 'no_class_eight_trucks':
          return 'text-dark-gray';
        case 'fatal_crash_with_citation':
          return 'text-red-500';
        default:
          return 'text-orange-500';
      }
    };
    const iconName = function (is_type) {
      switch (is_type) {
        case 'undeliverable_address':
          return 'question';
        case 'residential_address':
          return 'question';
        case 'no_class_eight_trucks':
          return 'question';
        default:
          return 'exclamation';
      }
    };
    const selectInsight = (id) => {
      selectedId.value = id;
    };
    const selectedInsight = computed(() => {
      return selectedInsights.value.find(
        (insight) => insight.id === selectedId.value
      );
    });
    return {
      modules: [Pagination],
      categories,
      Tabs,
      ViewMode,
      viewMode,
      toogleViewMode,
      currentTab,
      setTab,
      selectedInsight,
      selectInsight,
      selectedInsights,
      selectedId,
      iconColorClass,
      iconName,
      hasInsights,
      tabCount,
      carousel,
      onSlideChange,
    };
  },
  computed: {
    totalInsightText() {
      return this.screenWidth < 400
        ? 'Total Insights'
        : 'Total Insights Discovered';
    },
    totalInsightSize() {
      return this.screenWidth < 400 ? 'md' : 'lg';
    },
    insight_usage() {
      return 0;
    },
    insight_limit() {
      return this.$store.state.users.currentUser?.paywall?.max_insights_views;
    },
    paywallCheck() {
      if (this.insight_limit == null) {
        return false;
      } else if (
        this.insight_usage > this.insight_limit ||
        this.insight_usage == this.insight_limit
      ) {
        return true;
      } else {
        return false;
      }
    },
    hqAddress() {
      return this.$store.state.carriers.showCarrier?.contact_information
        ?.headquarters?.address;
    },
    brokerAuthorityNearbyInsight() {
      if (this.insights?.length > 0) {
        return (
          this.insights.find(
            (insight) => insight.is_type === 'broker_authority_nearby'
          ) || {}
        );
      } else {
        return {};
      }
    },
    carrier_id() {
      return this.$store.state.show?.showBroker?.carrier_company_id;
    },
  },
  methods: {
    getVoipPhone(phones) {
      if (!phones) return null;
      return phones.find((phone) => phone.phone_type === 'voip') || null;
    },
    capitalizeWords: function (str) {
      return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
        .replace('Llc', 'LLC');
    },
  },
};
</script>

<style scoped>
.list-container {
  height: 539px;
}
</style>
